import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.includes.js";
import axios from "axios";
import { Message } from "element-ui";
import store from "@/store";
import { getToken, getRfleshToken } from "@/utils/auth";
import publicApi from "/public/web/static/js/publicApi";
import { encryption, generateRandomOpenId } from "@/utils/sm4"; // const config = require('../../vue.config.js')
// let userType = config.devServer.overlay.userType

var userType = process.env.VUE_APP_USER_TYPE; // create an axios instance

var service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 50000 // request timeout

}); // request interceptor

service.interceptors.request.use(function (config) {
  var randomOpenId = generateRandomOpenId();
  config.headers["openid"] = randomOpenId;
  var _token = "";

  if (config.headers["openid"]) {
    var _time = new Date().getTime();

    _token = "".concat(config.headers["openid"], ",").concat(_time);
  }

  config.headers["token"] = _token ? encryption(_token) : ""; // do something before request is sent

  if (publicApi.includes(config.url)) {
    config.headers["89aa4b196b48c8a13a6549bb1eaebd80"] = 1;
  } else if (store.state.app.menuId) {
    config.headers["89aa4b196b48c8a13a6549bb1eaebd80"] = store.state.app.menuId;
  } else {
    config.headers["89aa4b196b48c8a13a6549bb1eaebd80"] = 1;
  }

  config.headers["userType"] = userType;

  if (store.getters.token) {
    // let each request carry token
    // ['X-Token'] is a custom headers key
    // please modify it according to the actual situation
    config.withCredentials = true;

    if (store.getters.token) {
      config.headers["access_token"] = getToken();
      config.headers["refresh_token"] = getRfleshToken();
    }

    return config;
  }

  return config;
}, function (error) {
  // do something with request error
  console.log(error); // for debug

  return Promise.reject(error);
}); // response interceptor

service.interceptors.response.use(
/**
 * If you want to get http information such as headers or status
 * Please return  response => response
 */

/**
 * Determine the request status by custom code
 * Here is just an example
 * You can also judge the status by HTTP Status Code
 */
function (response) {
  var res = response.data; // if the custom code is not 20000, it is judged as an error.

  if (res.code !== 200 && res.code !== 205) {
    Message({
      message: res.message,
      type: "error",
      duration: 5 * 1000
    }); // 508:非法的token; 512:其他客户端登录了;  514:Token 过期了;

    if (res.code === 508 || res.code === 512 || res.code === 514 || res.code === 230001) {
      Message.confirm("你已被登出，可以取消继续留在该页面，或者重新登录", "确定登出", {
        confirmButtonText: "重新登录",
        cancelButtonText: "取消",
        type: "warning"
      }).then(function () {
        store.dispatch("FedLogOut").then(function () {
          location.href = "http://" + window.location.host + "/login"; // location.reload()
        });
      });
    } else if (res.code === 401) {
      // 401自动跳到登录页
      store.dispatch("FedLogOut").then(function () {
        console.log("退出登录");
        location.href = "http://" + window.location.host + "/login";
      });
      Message({
        message: "您没有访问该页面的权限，已自动跳转到登录页面",
        type: "success",
        duration: 5 * 1000
      });
    }

    return Promise.reject("error");
  } else {
    if (res.data !== null && res.data && res.data.statusCodeValue === 204) {
      Message({
        message: "您已退出登录",
        type: "success",
        duration: 5 * 1000
      });
    }

    if (res.code === 205) {
      Message({
        message: res.message,
        type: "error",
        duration: 5 * 1000
      });
    }

    return response;
  }
}, function (error) {
  if (error == "Error: Request failed with status code 403") {
    Message({
      message: "您没有访问该接口的权限",
      type: "error",
      duration: 5 * 1000
    });
  } else if (error == "Error: Request failed with status code 401") {
    // 401自动跳到登录页
    setTimeout(function () {
      store.dispatch("FedLogOut").then(function () {
        console.log("退出登录");
        location.href = "http://" + window.location.host + "/login";
      });
    }, 2000);
    Message({
      message: "您没有访问该页面的权限，准备自动跳转到登录页面...",
      type: "success",
      duration: 5 * 1000
    });
  } else {
    Message({
      message: error.message,
      type: "error",
      duration: 5 * 1000
    });
  }

  console.log("error: " + error); // for debug

  return Promise.reject(error);
});
export default service;